<div class="format-filter-wrapper">
  <ng-container *ngFor="let elem of resourceFormats">
    <button
      mat-flat-button
      class="btn-icon-text"
      [opacTooltip]="getFormatIcon(elem.format).key | translate"
      [class.selected]="elem.selected"
      (click)="changeSelectedFormat(elem.format)">
      <span class="odilo-icon filter-icon" aria-hidden="true">{{ getFormatIcon(elem.format).icon }}</span>
      <span class="text" aria-hidden="true">{{ getFormatIcon(elem.format).key | translate }}</span>
    </button>
  </ng-container>
</div>
